"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pronunciationWordSchema = exports.pronunciationSyllableSchema = exports.pronunciationPhonemeSchema = exports.pronunciationWordContextSchema = exports.pronunciationLabelSchema = void 0;
const zod_1 = require("zod");
exports.pronunciationLabelSchema = zod_1.z.enum(["red", "yellow", "green"]);
exports.pronunciationWordContextSchema = zod_1.z.object({
    type: zod_1.z.enum(["text", "highlight"]),
    display: zod_1.z.string().nullish(),
    value: zod_1.z.string(),
});
exports.pronunciationPhonemeSchema = zod_1.z.object({
    phoneme: zod_1.z.string(),
    score: zod_1.z.number(),
    label: exports.pronunciationLabelSchema,
});
exports.pronunciationSyllableSchema = zod_1.z.object({
    syllable: zod_1.z.string(),
    grapheme: zod_1.z.string().optional(),
    graphemeDisplay: zod_1.z.string().optional(),
    accuracyScore: zod_1.z.number(),
    label: exports.pronunciationLabelSchema,
    labeledPhonemes: zod_1.z.array(exports.pronunciationPhonemeSchema),
});
exports.pronunciationWordSchema = zod_1.z.object({
    word: zod_1.z.string(),
    wordDisplay: zod_1.z.string(),
    startsAt: zod_1.z.number(),
    endsAt: zod_1.z.number(),
    context: zod_1.z.array(exports.pronunciationWordContextSchema).optional(),
    contextStartsAt: zod_1.z.number().nullish(),
    contextEndsAt: zod_1.z.number().nullish(),
    accuracyScore: zod_1.z.number(),
    label: exports.pronunciationLabelSchema,
    syllables: zod_1.z.array(exports.pronunciationSyllableSchema),
});
//# sourceMappingURL=pronunciation.js.map